<template>
  <div class="RADashboardAnalytics">
    <MobileNav :page_title="nav_title"></MobileNav>

    <div class="sideBarSection">
      <PlainSideBar v-if="isDesktop" :activeSection="selectedSection" @section-change="handleSectionChange"></PlainSideBar>
    </div>

    <div class="button-row">
      <div class="button-group">
        <button v-for="btn in buttons" :key="btn.label" :class="['btn', { active: activeBtn === btn.name }]" @click="activeBtn = btn.name">
          {{ btn.label }}
        </button>
      </div>
    </div>

    <div v-if="isDesktop">
      <div class="outer text-center" v-if="(userProfile.is_active_ra && activeBtn == 'premium') || activeBtn == 'chat'">
        <h5 class="head" style="color: #c6a555; margin: 0px">StockAnts Data Connected Partners</h5>
        <div class="marquee-container">
          <marquee scrollamount="15" behavior="scroll" direction="left" ref="marquee">
            <img src="../assets/images/logo/5paisa.jpeg" alt="5paisa" title="5paisa" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/alicebluelogo.png" alt="Alice Blue" title="Alice Blue" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/AngelOne.png" alt="Angel One" title="Angel One" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/bigulLgLogo.svg" alt="Bigul" title="Bigul" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/choiceLogo.png" alt="Choice" title="Choice" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/DhanLogo.png" alt="Dhan" title="Dhan" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/fyers.png" alt="Fyers" title="Fyers" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Maitra logo.png" alt="Maitra" title="Maitra" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/NuvamaLogo.jpeg" alt="Nuvama" title="Nuvama" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Paytm_Money_Logo.png" alt="Paytm Money" title="Paytm Money" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/rmoney logo.png" alt="RMoney" title="RMoney" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/navia Logo.png" alt="Navia" title="Navia" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/skiCapitalNew.jpeg" alt="SKI Capital" title="SKI Capital" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/share-India PNG.png" alt="Share India" title="Share India" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/almondz-logo (1).png" alt="Almondz" title="Almondz" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Ashlar.jpeg" alt="Ashlar" title="Ashlar" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Bajaj Logo.png" alt="Bajaj" title="Bajaj" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Multigain.jpeg" alt="Multigain" title="Multigain" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/upstox logo.svg" alt="Upstox" title="Upstox" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <!-- <img
              src="../assets/images/logo/BlinX Logo.png"
              alt="BlinX"
              title="BlinX"
              @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee"
            /> -->
            <img src="../assets/images/logo/Parasram logo.jpg" alt="Parasram" title="Parasram" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/enrich_money_logo.jpg" alt="Enrich Money" title="Enrich Money" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/choiceLogo.png" alt="Choice" title="Choice" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Rupeezy (1).svg" alt="Rupeezy" title="Rupeezy" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Motisonsshares2.jpeg" alt="Motisons" title="Motisons" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/daily gong logo.png" alt="Daily Gong" title="Daily Gong" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/ISS Enterprise logo.jpg" alt="DailyGongPlus" title="DailyGongPlus" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/logo_ol_company_logo.png" alt="GCL" title="GCL" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/SmartDelta App Logo.png" alt="SmartDelta" title="SmartDelta" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/HDFC SKY Logo.svg" alt="HDFC SKY" title="HDFC SKY" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />

            <img src="../assets/images/logo/Supernal Ventures Logo.svg" alt="Supernal Ventures" title="Supernal Ventures" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/SSCorporateLogo.png" alt="SS Corporate" title="SS Corporate" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Findoclogo.svg" alt="Findoc" title="Findoc" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Aetram Logo.jpg" alt="Aetram" title="Aetram" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Bullforce Logo.png" alt="Bullforce" title="Bullforce" @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
          </marquee>
        </div>
      </div>

      <!-- {{ user_details }} -->
      <NonActiveRAComponent style="height: 100%" v-if="userProfile && !userProfile.is_active_ra && activeBtn != 'chat'"></NonActiveRAComponent>

      <div class="cover-page-container" :style="[(!userProfile.is_active_ra && activeBtn == 'premium') ? { marginTop: '80px' } : { marginTop: '15px' }]">
        <!-- Heading section -->
        <div class="flex-space-between user-details-section">
          <div class="label-lg-black-bold">
            <span class="crown-outer">
              <img src="../assets/images/RA-dashboard/Active RA - Crown Icon.svg" alt="" />
            </span>
            User Details
          </div>
          <div>
            <div style="height: 25px">&nbsp;</div>
            <div class="flex" style="margin-top: 7px; align-items: baseline; justify-content: end">
              <!-- <div class="input-label-bold-gray" style="margin-top: 0;">
                      Download:
                    </div> -->
              <el-button class="download-btn export-btn flex" @click="handleExportBasedOnTab" :disabled="isExportDisabled" :loading="is_export_Loading">
                <span style="position: relative; top: -2px">
                  Export
                  <i class="el-icon-document" style="font-size: 20px; margin-left: 3px; position: relative; top: 2px"></i>
                </span>
              </el-button>
            </div>
          </div>
        </div>

        <!-- Table filter section -->

        <div class="filter-section">
          <el-row :gutter="15" style="align-items: center">
            <el-col :xs="24" :sm="2" :md="2" :lg="2" :xl="2">
              <div class="label-xs-bold right-margin-15" style="margin-top: 11px">Sort By:</div>
            </el-col>
            <el-col :xs="24" :sm="22" :md="22" :lg="22" :xl="22">
              <div class="flex-space-between">
                <div class="flex">
                  <div>
                    <div class="input-label-bold-gray">Past Duration:</div>
                    <div class="flex">
                      <el-select v-model="active_period" size="mini" placeholder="1 Month" style="width: 90px; margin-right: 18px" @change="filterUserData()">
                        <el-option v-for="period in period_list" :key="period.value" :label="period.label" :value="period.value"></el-option>
                      </el-select>
                    </div>
                  </div>

                  <div>
                    <div class="input-label-bold-gray">Status:</div>
                    <div class="flex">
                      <el-select v-model="status" size="mini" placeholder="Status" style="width: 90px; margin-right: 18px" @change="filterUserData()">
                        <el-option v-for="status in status_list" :key="status.value" :label="status.label" :value="status.value"></el-option>
                      </el-select>

                      <!-- <el-button
                        size="mini"
                        class="btn-light-blue-filled"
                        @click="filterUserData()"
                        >Show Result</el-button
                      > -->
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- <div v-if="subscribedUsersList.length" > -->
        <div v-if="activeBtn === 'premium' && (subscribedUsersList.length || is_user_list_loading)" v-loading="is_user_list_loading">
          <div class="board-table-outer">
            <table class="outer-board-table board-table">
              <thead>
                <tr class="main-head">
                  <th>Reference</th>
                  <th style="min-width: 100px">Name</th>
                  <th style="min-width: 150px">Email</th>
                  <!-- <th style="min-width: 70px;">Mobile</th> -->
                  <th style="min-width: 70px">Pan</th>
                  <th style="min-width: 50px">Plan</th>
                  <th style="min-width: 50px">Plan Duration</th>
                  <th style="min-width: 150px">Subscribed Date/Time</th>
                  <th style="min-width: 50px">Status</th>
                  <!-- <th style="min-width: 50px;" class="text-center">Invoice</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in subscribedUsersList">
                  <td class="external-link-color" style="text-decoration: underline; cursor: pointer">
                    <div @click="downloadPdf(data.invoice_url)">
                      {{ data.invoice_no }}
                    </div>
                  </td>
                  <td>{{ data.user_name }}</td>
                  <td>{{ data.email }}</td>
                  <!-- <td>{{ data.mobile ? data.mobile : "-" }}</td> -->
                  <td>{{ data.pan_number }}</td>
                  <td>{{ data.plan_name }}</td>
                  <td>{{ data.plan_duration }}</td>
                  <td>
                    {{ moment(data.subscription_datetime).format('MMM DD YYYY, h:MMA') }}
                  </td>
                  <td class="live" :class="data.plan_status == 'Live' ? 'live' : 'expired'">
                    {{ data.plan_status }}
                  </td>
                  <!-- <td class="text-center">
                    <i
                      class="el-icon-bottom font-weight-700 download-btn"
                      style="font-size: 13px;"
                      @click="downloadPdf(data.invoice_url)"
                    ></i>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <div class="pagination" style="text-align: center">
            <el-pagination @current-change="handleCurrentChange" :current-page="pagination.current_page" :page-sizes="[5, 10, 20, 50]" :page-size="pagination.page_size" :total="pagination.total_entries" :pager-count="5" layout="total, prev, pager, next"></el-pagination>
          </div>
        </div>

        <div v-if="activeBtn === 'premium' && !is_user_list_loading && !subscribedUsersList.length">
          <NoDataFound></NoDataFound>
        </div>

        <div v-if="activeBtn === 'chat' && (chatUsersList.length || is_chat_list_loading)" v-loading="is_chat_list_loading">
          <div class="board-table-outer">
            <table class="outer-board-table board-table">
              <thead>
                <tr class="main-head">
                  <th>Reference</th>
                  <th style="min-width: 100px">Name</th>
                  <th style="min-width: 150px">Email</th>
                  <th style="min-width: 70px">Mobile</th>
                  <th style="min-width: 70px">Pan</th>
                  <th style="min-width: 120px">Chat Initiated Time</th>
                  <th style="min-width: 130px">Expert Entry Time</th>
                  <th style="min-width: 130px">Expert Exit Time</th>
                  <th style="min-width: 130px">User Entry Time</th>
                  <th style="min-width: 130px">User Exit Time</th>
                  <th style="min-width: 80px; white-space: normal">Chat Status</th>
                  <th style="min-width: 60px; white-space: normal">Review</th>
                  <th style="min-width: 70px; white-space: normal">Transcript</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in chatUsersList" :key="index">
                  <td>
                    <a v-if="data.invoice_url" :href="data.invoice_url" target="_blank" class="external-link-color" style="text-decoration: underline">Invoice</a>
                    <span v-else>--</span>
                  </td>
                  <td>{{ data.user_name }}</td>
                  <td>{{ data.email }}</td>
                  <td>{{ data.mobile || '-' }}</td>
                  <td>{{ data.pan_number || '-' }}</td>
                  <td>{{ moment(data.chat_initiated_time).format('MMM DD YYYY, h:mm A') }}</td>
                  <td>{{ moment(data.expert_entry_time).format('MMM DD YYYY, h:mm A') }}</td>
                  <td>{{ moment(data.expert_exit_time).format('MMM DD YYYY, h:mm A') }}</td>
                  <td>{{ moment(data.user_entry_time).format('MMM DD YYYY, h:mm A') }}</td>
                  <td>{{ moment(data.user_exit_time).format('MMM DD YYYY, h:mm A') }}</td>
                  <td :class="data.chat_status === 'Live' ? 'live' : 'expired'">
                    {{ data.chat_status }}
                  </td>
                  <td>
                    <span v-if="data.review && data.review.userLikeExperience" @click="openReviewDialog(data.review)" style="cursor: pointer; text-decoration: underline; color: #409eff">
                      {{ data.review.userLikeExperience }}
                    </span>
                    <span v-else>--</span>
                  </td>
                  <td style="text-align: center">
                    <a v-if="data.transcript" :href="data.transcript" target="_blank" class="el-icon-bottom font-weight-700 download-btn" style="text-decoration: underline"></a>
                    <span v-else>--</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="pagination" style="text-align: center; margin-top: 20px">
            <el-pagination @current-change="handleChatPageChange" :current-page="chatPagination.current_page" :page-sizes="[5, 10, 20, 50]" :page-size="chatPagination.page_size" :total="chatPagination.total_entries" :pager-count="5" layout="total, sizes, prev, pager, next"></el-pagination>
          </div>
        </div>

        <div v-if="activeBtn === 'chat' && !is_chat_list_loading && !chatUsersList.length">
          <NoDataFound></NoDataFound>
        </div>
      </div>
      <!-- Below dialog for user Review details -->
      <el-dialog title="User Review" :visible.sync="reviewDialogVisible" width="400px" :close-on-click-modal="false" custom-class="review-popup" :show-close="false">
        <!-- close button -->
        <span class="custom-close" @click="reviewDialogVisible = false">×</span>

        <div class="review-content">
          <div v-if="selectedReview && selectedReview.reviewOptions && selectedReview.reviewOptions.length">
            <ul class="review-list">
              <li v-for="(option, index) in selectedReview.reviewOptions" :key="index">
                {{ option }}
              </li>
            </ul>
          </div>
          <div v-else class="no-review-msg">-- No review options found --</div>
        </div>
      </el-dialog>
    </div>

    <div v-else>
      <NonActiveRAComponent style="height: 100%" v-if="userProfile && !userProfile.is_active_ra"></NonActiveRAComponent>

      <div class="cover-page-container" v-if="userProfile && userProfile.is_active_ra">
        <div class="block-mob-view">To access the Dashboard Analytics, please log in via desktop for an enhanced user experience.</div>
      </div>
    </div>
  </div>
</template>

<script>
var echarts = require('echarts');
import { serverAddr, serverHostName, serverAddrForCSV, serverAddrForChat, chatServerHostName } from '../networkConfig.js';
import { graphData } from '../mixins/AnalyticsGraphData.js';
import { filterCallBack } from '../mixins/filter.js';
import PlainSideBar from '@/components/PlainSideBar.vue';
import MobileNav from '@/components/MobileNav.vue';
import Hexagon from '@/components/Hexagon.vue';
import NoDataFound from '@/components/NoDataFound.vue';
import { screenSize } from '../mixins/ScreenSize.js';
import { required } from 'vuelidate/lib/validators';
import CripNotice from 'crip-vue-notice';
import { HelperNetworkCallBack } from '../mixins/Helper.js';
import moment from 'moment';
import axios from 'axios';
import NonActiveRAComponent from '@/components/NonActiveRA.vue';
import ExcelJS from 'exceljs';

export default {
  name: 'RADashboardAnalytics',

  mixins: [filterCallBack, graphData, screenSize, HelperNetworkCallBack],

  components: {
    PlainSideBar,
    MobileNav,
    Hexagon,
    NoDataFound,
    NonActiveRAComponent,
  },

  data() {
    return {
      selectedSection: 'chat',
      nav_title: "Expert's Analytics",
      serverHostName: serverHostName,
      chatServerHostName: chatServerHostName,
      moment: moment,
      pickerOptions: {
        shortcuts: [
          {
            text: 'This month',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            },
          },
          {
            text: 'This year',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Last 6 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      value1: '',
      value2: '',
      subscribedUsersList: [],

      status_list: [
        { label: 'All', value: 'All' },
        { label: 'Live', value: 'Live' },
        { label: 'Expired', value: 'Expired' },
      ],
      status: 'All',
      pagination: [],
      currentPage: 1,
      active_period: '1M',
      period_list: [
        {
          label: '1 Month',
          value: '1M',
        },
        {
          label: '3 Month',
          value: '3M',
        },
        {
          label: '6 Month',
          value: '6M',
        },
        {
          label: '1 Year',
          value: '1Y',
        },
      ],
      is_export_Loading: false,
      is_user_list_loading: false,
      exportUserList: [],
      userProfile: localStorage.getItem('profile') ? JSON.parse(localStorage.getItem('profile')) : {},
      activeBtn: 'premium',
      buttons: [
        { name: 'premium', label: 'Premium' },
        { name: 'chat', label: 'Chat' },
      ],
      chatUsersList: [],
      is_chat_list_loading: false,
      chatPagination: {
        current_page: 1,
        page_size: 10,
        total_entries: 0,
      },
      reviewDialogVisible: false,
      selectedReview: null,
    };
  },

  validations: {
    // review_title: {
    //     required
    // },
    review: {
      required,
    },
  },

  mounted() {
    //returns stored user profile from local storage
    if (localStorage.getItem('profile')) {
      this.userProfile = JSON.parse(localStorage.getItem('profile'));
    }

    // this.initGraphInstance();
    // this.combinedApis();
    if (this.isDesktop) {
      this.checkLoginUserDetail();
    }
    this.getSubscribedUsersList();
    this.getChatUsersList();
  },
  watch: {
    activeBtn(newVal) {
      if (newVal === 'premium') this.getSubscribedUsersList();
      else if (newVal === 'chat') this.getChatUsersList();
    },
    // user_details(newValue, oldValue) {
    //   console.log(newValue);
    //   if (newValue && newValue.mark_as_verified && newValue.is_active_ra && this.isDesktop) {
    //     this.getSubscribedUsersList(false);
    //   }
    // },
  },

  methods: {
    handleExportBasedOnTab() {
      if (this.activeBtn === 'premium') {
        this.getTotalEntriesForExport();
      } else if (this.activeBtn === 'chat') {
        this.getTotalChatEntriesForExport();
      }
    },

    // Method for review dialog
    openReviewDialog(review) {
      this.selectedReview = review;
      this.reviewDialogVisible = true;
    },

    // Method for chat user list
    getChatUsersList() {
      this.is_chat_list_loading = true;

      const params = {
        page_no: this.chatPagination.current_page,
        page_per_entries: this.chatPagination.page_size,
      };

      serverAddrForChat
        .get('/v1/chat/ra_dashboard', {
          params: params,
        })
        .then((response) => {
          if (response.data.status) {
            this.chatUsersList = response.data.data;
            this.chatPagination = response.data.pagination;
          }
          this.is_chat_list_loading = false;
        })
        .catch((error) => {
          console.error('Error fetching chat users:', error);
          this.is_chat_list_loading = false;
        });
    },

    handleChatPageChange(val) {
      this.chatPagination.current_page = val;
      this.getChatUsersList(false);
    },
    handleSectionChange(section) {
      this.selectedSection = section;
    },
    pauseMarquee() {
      this.$refs.marquee.stop(); // Pauses the marquee scroll
    },
    resumeMarquee() {
      this.$refs.marquee.start(); // Resumes the marquee scroll
    },
    async checkLoginUserDetail() {
      if (this.userProfile && this.userProfile.mark_as_verified_user && this.userProfile.is_active_ra) {
        this.getSubscribedUsersList(false);
      }
    },
    filterUserData() {
      this.currentPage = 1;
      this.getSubscribedUsersList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getSubscribedUsersList(false);
    },
    downloadPdf(path) {
      window.open(`${this.serverHostName + '/' + path}`, '_blank');
    },

    async downloadExcel() {
      this.is_export_Loading = true;
      try {
        // Fields to remove
        const fieldsToRemove = ['plan_name', 'invoice_url', 'mobile'];

        // Remove specified fields from each object in the array
        const newData = this.exportUserList.map((obj) => {
          const newObj = { ...obj }; // Create a shallow copy of the original object
          fieldsToRemove.forEach((field) => {
            delete newObj[field]; // Delete the specified field from the copied object
          });
          return newObj; // Return the modified object
        });

        const data = newData;
        // Create a new workbook
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        // Add headers
        const headers = Object.keys(data[0]);
        worksheet.addRow(headers);

        // Add data to worksheet
        data.forEach((item) => {
          const rowValues = headers.map((header) => item[header]);
          worksheet.addRow(rowValues);
        });

        // Set column widths
        ['A', 'B', 'D', 'E', 'F'].forEach((column) => {
          worksheet.getColumn(column).width = 18; // Example width
        });

        ['C', 'F'].forEach((column) => {
          worksheet.getColumn(column).width = 28; // Example width
        });

        ['D', 'G'].forEach((column) => {
          worksheet.getColumn(column).width = 14; // Example width
        });

        // Generate Excel file
        const buffer = await workbook.xlsx.writeBuffer();

        // Create Blob
        const blob = new Blob([buffer], { type: 'application/octet-stream' });

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'StockAnts User Subscription List.xlsx';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error exporting to Excel:', error);
      }
      this.is_export_Loading = false;
    },

    // Download excel for Chat RA dashboard
    async downloadChatExcel() {
      this.is_export_Loading = true;
      try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Chat Users');

        const columns = [
          { key: 'invoice_url', header: 'Reference' },
          { key: 'user_name', header: 'Name' },
          { key: 'email', header: 'Email' },
          { key: 'mobile', header: 'Mobile' },
          { key: 'pan_number', header: 'Pan' },
          { key: 'chat_initiated_time', header: 'Chat Initiated Time' },
          { key: 'expert_entry_time', header: 'Expert Entry Time' },
          { key: 'expert_exit_time', header: 'Expert Exit Time' },
          { key: 'user_entry_time', header: 'User Entry Time' },
          { key: 'user_exit_time', header: 'User Exit Time' },
          { key: 'chat_status', header: 'Chat Status' },
          { key: 'review', header: 'Review' },
          { key: 'transcript', header: 'Transcript' },
        ];

        worksheet.addRow(columns.map((col) => col.header));

        this.chatExportList.forEach((item) => {
          const row = columns.map(({ key }) => {
            const keys = key.split('.');
            let value = keys.reduce((obj, k) => (obj && obj[k] !== undefined ? obj[k] : null), item);

            // Format proper datetime fields
            const datetimeKeys = ['chat_payment_time', 'chat_initiated_time', 'expert_entry_time', 'expert_exit_time', 'user_entry_time', 'user_exit_time', 'first_chat', 'latest_chat'];

            if (datetimeKeys.includes(key)) {
              value = value ? moment(value).format('MMM DD YYYY, h:mm A') : '--';
            } else if (Array.isArray(value)) {
              value = value.join(', '); // for reviewOptions
            } else if (key === 'invoice_url') {
              value = item.invoice_url ? 'Invoice' : '--';
            } else if (key === 'transcript') {
              value = item.transcript ? 'Available' : '--';
            } else if (value === 0) {
              value = '0';
            } else {
              value = value !== null && value !== undefined && value !== '' ? value : '--';
            }

            return value;
          });

          worksheet.addRow(row);
        });

        worksheet.columns.forEach((col) => {
          col.width = 25;
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'StockAnts_Chat_User_List.xlsx';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error exporting chat Excel:', error);
      }
      setTimeout(() => {
        this.is_export_Loading = false;
      }, 100);
    },

    getSubscribedUsersList(isExport) {
      this.is_user_list_loading = true;

      var obj = {};
      obj.page_no = this.currentPage;
      // obj.page_per_entries = 10;
      obj.status = this.status == 'All' ? '' : this.status;
      obj.period = this.active_period;
      obj.is_export = false;

      serverAddr
        .post('/my_dashboard/v1/ra_dashboard', obj)
        .then((response) => {
          if (response.data.status) {
            this.subscribedUsersList = response.data.data;
            this.pagination = response.data.pagination;
          } else {
          }
          setTimeout(() => {
            this.is_user_list_loading = false;
          }, 100);
        })
        .catch(
          function (error) {
            console.log(error);
            this.is_user_list_loading = false;
          }.bind(this)
        );
    },

    // For Premium data export
    getTotalEntriesForExport() {
      if (!this.exportUserList.length) {
        var obj = {};
        obj.page_no = 1;
        obj.page_per_entries = this.pagination.total_entries;
        obj.status = '';
        obj.period = this.active_period;
        obj.is_export = false;

        this.is_export_Loading = true;

        serverAddr
          .post('/my_dashboard/v1/ra_dashboard', obj)
          .then((response) => {
            if (response.data.status) {
              this.exportUserList = response.data.data;
              this.downloadExcel();
            }
            this.is_export_Loading = false;
          })
          .catch(
            function (error) {
              this.is_export_Loading = false;
              console.log(error);
            }.bind(this)
          );
      } else {
        this.downloadExcel();
      }
    },

    // For chat export
    getTotalChatEntriesForExport() {
      var obj = {};
      obj.page_no = 1;
      obj.page_per_entries = this.pagination.total_entries;
      obj.status = '';
      obj.period = this.active_period;
      obj.is_export = false;

      this.is_export_Loading = true;

      serverAddrForChat
        .get('/v1/chat/ra_dashboard', obj)
        .then((response) => {
          if (response.data.status) {
            this.chatExportList = response.data.data; // store for export
            this.downloadChatExcel();
          }
          setTimeout(() => {
            this.is_export_Loading = false;
          }, 100);
        })
        .catch((error) => {
          console.log(error);
          this.is_export_Loading = false;
        });
    },
  },

  computed: {
    isExportDisabled() {
      if (this.activeBtn === 'premium') {
        return !this.subscribedUsersList.length || this.is_export_Loading;
      } else if (this.activeBtn === 'chat') {
        return !this.chatUsersList.length || this.is_export_Loading;
      }
      return true;
    },
    // return user details e.g. accuracy, success rate, rating etc.
    // user_details() {
    //   return this.$store.state.user_details;
    // },

    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem('plan_details'));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.RADashboardAnalytics {
  min-height: calc(100vh - 60px);
  background-color: $page-background-color;
  padding: 60px 0 0 0;

  .block-mob-view {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    color: $secondary-theme-color;
    font-weight: 600;
    padding: 20px;
    text-align: center;
  }
  .outer {
    background-color: #feffe5;
    text-align: center;
    padding: 10px 0px 20px;
    width: calc(100% - 265px);
    margin-left: 265px;
  }

  .button-row {
    display: flex;
    justify-content: flex-end;
    margin: 10px;
    .button-group .btn {
      background-color: #e9f3ff;
      border: 1px solid #2488ff;
      color: #2488ff;
      padding: 6px 12px;
      cursor: pointer;
      border-radius: 0;
    }
    .button-group .btn:first-child {
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }
    .button-group .btn:last-child {
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }
    .button-group .btn.active {
      background-color: #2488ff;
      color: white;
    }
  }
  .marquee-container img {
    max-height: 35px;
    margin-right: 60px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  // Below css for Marquee tag
  marquee {
    height: 100px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    box-sizing: border-box;
    padding-top: 10px;
    padding-bottom: 10px;
    justify-content: center;
  }

  @keyframes marquee {
    0% {
      transform: translateX(100%);
    }

    100% {
      transform: translateX(-100%);
    }
  }
  .cover-page-container {
    width: calc(100% - 295px);
    margin-left: 280px;
    margin-top: 15px;
    padding-bottom: 10px;
    // padding: 20px 0;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0px 0px 7px 1px #dcd6d6;
    position: relative;
    bottom: 70px;
    .export-btn {
      font-size: 12px;
      padding: 4px 10px;
      margin-left: 8px;
    }
    .board-table-outer {
      border-top: 4px solid #bea66e;
      overflow-x: auto;
      min-height: 370px;

      .live {
        color: #079e3e;
      }

      .expired {
        color: #e72726;
      }
      .download-btn {
        padding: 5px 8px;
        font-size: 12px;
        width: 15px;
        margin: 0 auto;
        box-shadow: 0px 1px 3px 1px #e0e0e0;
      }
      .sub-section {
        padding: 0 !important;
      }
      .sub-sec-head {
        width: 100%;
        text-align: left;
        background-color: #2d2e8d;
        padding: 10px;
        color: #ffff;
        margin: 10px 0 0;
        font-weight: 600;
      }
    }
    .board-table {
      overflow-x: auto;
      border-spacing: 0;
      border-collapse: collapse;
      width: 100%;
      text-align: left;

      .main-head th {
        color: #000;
      }

      .border-right-gray {
        border-right: 1px solid #e9e9e9;
      }
      .border-bottom-gray {
        border-bottom: 1px solid #e9e9e9;
      }
      .bottom-spacing-table-heading {
        padding: 0px 8px 8px 8px;
      }
      thead {
        tr {
          th {
            color: #a5a6a8;
            font-size: 0.8rem;
            font-weight: 700;
            padding: 10px 20px;
            white-space: nowrap;
          }
        }

        tr:nth-child(1) {
          border-bottom: 1px solid #e9e9e9;
          background-color: #ededed;
        }
      }
      tbody {
        // min-height: 300px;
        tr {
          td {
            font-size: 0.7rem;
            font-weight: 500;
            padding: 10px 15px;
            vertical-align: unset;
          }
        }
        // tr:hover {
        //   background-color: #eff5fe;
        // }

        tr:nth-child(even) td {
          background-color: #f1f7f8; /* Set background color for even rows */
        }
      }
    }

    .pagination {
      margin: 15px 0 10px;
    }
    .user-details-section {
      border-bottom: 1px solid #d5d5d5;
      padding: 10px 20px;
    }

    .crown-outer {
      background: #bea66e;
      padding: 2px 5px;
      border-radius: 5px;
      margin-right: 3px;
    }
    .filter-section {
      padding: 0 20px;
      margin-bottom: 15px;
    }
  }

  .footer-section {
    width: calc(100% - 260px);
    margin-left: 260px;
  }

  @media screen and (max-width: 1283px) {
    .cover-page-container,
    .footer-section {
      width: 100%;
      margin-left: 0;
      height: calc(100vh - 160px);
      margin-top: 85px;
    }
    .cover-page-container {
      //   padding: 20px 10px 0 10px;
    }
    .sideBarSection {
      display: none;
    }
  }
}
</style>

<style lang="scss">
.RADashboardAnalytics {
  .NoDataFound {
    padding: 15px 0 0 0;
  }
  .review-card {
    border-radius: 10px;
    .el-card__body {
      padding: 5px 20px;
    }
  }
  .analytics-card {
    border-radius: 10px;
  }

  .review-section,
  .user-access-section {
    .el-rate__icon {
      font-size: 14px !important;
      margin-right: 2px;
    }
  }

  .referal-dialog {
    .el-dialog__header .el-dialog__title {
      color: #000;
      font-weight: 500;
    }
  }

  // Css for review popup
  .review-popup {
    border-radius: 10px;
    padding: 10px;
    position: relative;

    .custom-close {
      position: absolute;
      top: 12px;
      right: 15px;
      font-size: 20px;
      color: #999;
      cursor: pointer;
      font-weight: bold;
      z-index: 2;
      transition: color 0.2s;

      &:hover {
        color: #333;
      }
    }

    .review-content {
      font-size: 14px;
      color: #333;
      line-height: 1.6;
      padding: 10px 5px;

      .review-list {
        padding-left: 18px;
        margin: 0;

        li {
          margin-bottom: 8px;
          list-style-type: disc;
        }
      }

      .no-review-msg {
        text-align: center;
        font-style: italic;
        color: #999;
        padding: 10px 0;
      }
    }
  }
  @media screen and (max-width: 992px) {
    .referal-dialog {
      width: 80% !important;
    }
  }
}
</style>
